import { updateEtatAsync } from '@/api/logistique/ordreTravailTech';

export default async function changerEtatOtTechnique(
  otTecniqueIds, etatAchanger, actionIntervention, impactEtatDemandes, isAnnulatonSuppression,
  dateOt,
) {
  let response = null;
  const data = {
    otsIds: otTecniqueIds,
    etatSouhaite: etatAchanger,
    realiserActionIntervention: actionIntervention,
    impactEtatDemandes: impactEtatDemandes,
    isAnnulatonSuppression: isAnnulatonSuppression,
    dateOt: dateOt,
  };
  response = await updateEtatAsync(data);

  return response;
}
